import { BreakpointKeyType } from '../styles/types';

/**
 * Useful to apply base classNames and another set of classNames at determined breakpoint.
 *
 * @param {string} baseCls - The base classnames (applied from mobile)
 * @param {string} responsiveCls - The responsive classNames applied from the given breakpoint
 * @param {'sm'|'md'|'lg'} breakpoint - The breakpoint key where we want to apply the responsive classes.
 *
 * @example
 * const baseCls = 'cls1 cls2 cls3 py-16';
 * const extraCls = 'cls3 cls4 py-24';
 * const finalCls = createResponsiveCls(baseCls, extraCls);
 *
 * console.log(finalCls); // cls1 cls2 cls3 cls4 py-16
 */
const createResponsiveCls: (
  baseCls?: string,
  responsiveCls?: string,
  breakpoint?: BreakpointKeyType,
) => string = (baseCls = '', responsiveCls = '', breakpoint = 'sm') => {
  const classArray: string[] = responsiveCls.split(' ');
  let responsiveClasses = baseCls;

  classArray.forEach(cls => {
    if (!responsiveClasses.includes(cls)) {
      responsiveClasses = responsiveClasses.concat(` ${breakpoint}:${cls}`);
    }
  });

  return responsiveClasses;
};

export default createResponsiveCls;
